import { render, staticRenderFns } from "./dataDescription.vue?vue&type=template&id=8803abb6&"
import script from "./dataDescription.vue?vue&type=script&lang=js&"
export * from "./dataDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports